import { render, staticRenderFns } from "./IviewFormSelect.vue?vue&type=template&id=2109f8e1&scoped=true&"
import script from "./IviewFormSelect.vue?vue&type=script&lang=js&"
export * from "./IviewFormSelect.vue?vue&type=script&lang=js&"
import style0 from "./IviewFormSelect.vue?vue&type=style&index=0&id=2109f8e1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2109f8e1",
  null
  
)

export default component.exports